import { useContext } from 'react';
import type { ObjectData } from '@os/doc';
import { RichText } from '../text/RichText';
import { CanvasAuthorsContext } from '../editor/CanvasAuthors';
import { ExportModeContext } from '../editor/embeds';
import { stickyAuthorInk, stickyInk } from '../../ui/palette';

/** A sticky: soft shadow, its text, and (P5e, FigJam-like) its author's first name bottom-left, never in an export; both in inks that read on its colour. */
export function StickyObject({ o }: { o: Extract<ObjectData, { type: 'sticky' }> }) {
  const author = useContext(CanvasAuthorsContext)(o.createdBy);
  const exporting = useContext(ExportModeContext);
  return (
    <div className="relative h-full w-full overflow-hidden break-words p-3 font-sans text-base shadow-[var(--sticky-shadow)]" style={{ background: o.color, color: stickyInk(o.color) }}>
      <div data-rich>
        <RichText doc={o.content} fallback={o.text} />
      </div>
      {author && !exporting && (
        <span data-sticky-author className="pointer-events-none absolute bottom-2 left-3 max-w-[calc(100%-1.5rem)] truncate font-sans text-[11px]" style={{ color: stickyAuthorInk(o.color) }}>
          {author}
        </span>
      )}
    </div>
  );
}
